module.exports = __webpack_public_path__ + "img/kakaxi_success.a487547e.gif";